<template>
    <div>
        <v-btn rounded="lg" prepend-icon="mdi-account-clock-outline" class="gradient-color-primary" block @click="openGrantTrialDialog">Trialzeitraum gewähren</v-btn>
        <v-dialog class="agency-change-slots-dialog" v-model="handleGrantTrialDialog" persistent>
            <v-card class="agency-change-slots-card" rounded="lg">
                <v-card-title class="agency-change-slots-card-title">Trialzeitraum gewähren:</v-card-title>
                <v-card-text class="agency-change-slots-card-text">Passt den Trialzeitraum in der Datenbank und bei Stripe an.</v-card-text>
                <v-text-field type="number" hide-details v-model="trialDays" :label="'Nummer in Tagen'"></v-text-field>
                <v-divider class="agency-change-slots-divider"></v-divider>
                <v-card-text class="agency-change-slots-card-text">Slotanzahl für den Testzeitraum:</v-card-text>
                <v-text-field type="number" hide-details v-model="newAmountSlots" :label="`Aktuell: ${agency.amountSlots}`"></v-text-field>
                <v-divider class="agency-change-slots-divider"></v-divider>
                <div class="agency-change-slots-button-group">
                    <v-btn rounded="lg" :disabled="loading" color="error" @click="openGrantTrialDialog">
                        Abbrechen
                    </v-btn>
                    <v-btn rounded="lg" :disabled="loading" class="gradient-color-primary" @click="grantTrial">
                        Anpassen
                    </v-btn>
                </div>
            </v-card>
        </v-dialog>
    </div>
</template>
<script>
import { mapState, mapActions } from 'vuex'

    export default {
        props: {
            agency: {
                type: Object,
                required: true
            }
        },
        data() {
            return {
                newAmountSlots: null,
                trialDays: 30,
                handleGrantTrialDialog: false,
            }
        },
        computed: {
            ...mapState('agency', ['loading']),
        },
        methods: {
            ...mapActions('agency', ['grantTrial', 'saveLog']),
            async grantTrial() {
                const agencyId = this.agency._id;
                const trialDays = this.trialDays;
                const amountSlots = this.newAmountSlots || this.agency.amountSlots;
                const updatedAgency = await this.$store.dispatch('agency/grantTrial', { agencyId, trialDays, amountSlots });
                if (updatedAgency) {
                    await this.$store.dispatch('agency/saveLog', {
                        agencyId: this.agency._id,
                        changes: [
                            {
                                date: new Date(),
                                description: `Trial granted for ${trialDays} days.`,
                                user: this.$store.state.loginAndOut.name // Fetch the name of the admin from the state
                            }
                        ],
                    });
                }
                this.handleGrantTrialDialog = false;
            },
            openGrantTrialDialog() {
                this.handleGrantTrialDialog = !this.handleGrantTrialDialog;
            }
        },
    }

</script>


<style lang="scss" scoped>

.agency-change-slots-dialog {
    max-width: 600px;
    margin: 0 auto;
}

.agency-change-slots-card {
    padding: 12px;
}

.agency-change-slots-card-title {
    font-size: 20px;
    font-weight: 600;
    padding: 4px 4px 24px 4px;
}

.agency-change-slots-divider {
    margin: 32px 0 12px 0;
}

.agency-change-slots-button-group {
    display: flex;
    justify-content: end;
    gap: 8px;
}

.agency-change-slots-card-text {
    padding: 4px 4px 8px 4px !important;
    font-size: 14px;
    font-weight: 500;
}

</style>